import React, { useState, useEffect, useRef } from "react";
type Props = {
  listData: any;
  selectedName: any;
  updateSelectedPIDForParent: Function;
  type: any;
};

export default function EyeMultiSelectionDropdown(props: Props) {
  const [showOptions, setShowOptions] = useState(false);
  const [selectedName, setSelectedName] = useState(props.selectedName);
  const componentRef = useRef<any>(null);
  const [currentList, setCurrentList] = useState<any>([]);
  const [selectUnSelectAll, setSelectUnSelectAll] = useState<any>(true);

  useEffect(() => {
    // Function to handle outside clicks
    const handleClickOutside = (event: any) => {
      // Check if the click target is outside the component's DOM node
      if (
        componentRef.current &&
        !componentRef.current.contains(event.target)
      ) {
        setShowOptions(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (props.listData && props.listData.length > 0) {
      const deepCopy1 = JSON.parse(JSON.stringify(props.listData));

      for (let index = 0; index < deepCopy1.length; index++) {
        if (props.type == 10001) {
          if (
            deepCopy1[index].PID == 20 ||
            deepCopy1[index].PID == 21 ||
            deepCopy1[index].PID == 2 ||
            deepCopy1[index].PID == 3
          ) {
            deepCopy1[index].IsSelected = true;
          } else deepCopy1[index].IsSelected = false;
        } else deepCopy1[index].IsSelected = true;
      }
      if (props.type == 10001 && deepCopy1.length < 4) {
        for (let index = 0; index < deepCopy1.length; index++) {
          deepCopy1[index].IsSelected = true;
        }
      }
      setCurrentList(deepCopy1);
    }
  }, [props.listData]);

  useEffect(() => {
    if (currentList && currentList.length > 0) {
      checkSelectUnselectAll();
    }
  }, [currentList]);

  function updateListdata(index: number) {
    let tempArray = [...currentList];
    tempArray[index].IsSelected = !tempArray[index].IsSelected;
    setCurrentList(tempArray);
  }

  function sendResponseToParent() {
    setShowOptions(false);
    let selectedIds = "";
    for (let i = 0; i < currentList.length; i++) {
      if (currentList[i].IsSelected) {
        selectedIds += currentList[i].PID + ",";
      }
    }
    if (selectedIds != "") {
      selectedIds = selectedIds.replace(/,$/, "");
    }
    props.updateSelectedPIDForParent(props.type, selectedIds);
  }

  function checkSelectUnselectAll() {
    let allChecked = true;
    for (let i = 0; i < currentList.length; i++) {
      if (currentList[i].IsSelected === false) {
        allChecked = false;
        break;
      }
    }
    setSelectUnSelectAll(allChecked);
  }

  function selectUnselectAll(event: any) {
    let l_currentList = [...currentList];
    if (event.target.checked) {
      //select all
      setSelectUnSelectAll(true);
      for (let i = 0; i < l_currentList.length; i++) {
        l_currentList[i].IsSelected = true;
      }
    } else {
      //unselect all
      setSelectUnSelectAll(false);
      for (let i = 0; i < l_currentList.length; i++) {
        l_currentList[i].IsSelected = false;
      }
    }

    setCurrentList(l_currentList);
  }

  return (
    <>
      <div className="multi-select multi-eye" ref={componentRef}>
        <a className="btn-primary" onClick={() => setShowOptions(!showOptions)}>
          <img src="/images/eye.svg" width="13" height="8" alt="Chev down" />
        </a>
        <div className={showOptions ? "multi-drop" : "multi-drop no-display"}>
          <div className="multi-list">
            <div className="multi-item">
              <input
                type="checkbox"
                value={selectUnSelectAll}
                checked={selectUnSelectAll}
                onChange={(e: any) => selectUnselectAll(e)}
              />
              <span>Select/Unselect All</span>
            </div>
            {currentList.map((item: any, index: any) => (
              <React.Fragment key={index}>
                <div className="multi-item">
                  <input
                    type="checkbox"
                    checked={item.IsSelected}
                    value={item.IsSelected}
                    onChange={(e: any) => updateListdata(index)}
                  />
                  <span>{item.Name}</span>
                </div>
              </React.Fragment>
            ))}
          </div>
          <a className="btn-primary" onClick={() => sendResponseToParent()}>
            Filter
          </a>
        </div>
      </div>
    </>
  );
}
